import styled from "styled-components";
import BackArrow from "assets/back-arrow.svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 28px 20px 18px;
`;

export const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
`;

export const Breadcrumb = styled.div<{ $isActive?: boolean }>`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  cursor: ${props => props.$isActive ? 'default' : 'pointer'};
`;

export const NextArrow = styled(BackArrow)`
  transform: rotate(180deg);
`;

export const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;